import Swiper, {Autoplay, EffectFade} from 'swiper';
import {gsap} from 'gsap';
import {ScrollToPlugin} from 'gsap/ScrollToPlugin';
Swiper.use([Autoplay, EffectFade]);
gsap.registerPlugin(ScrollToPlugin);

(function($) {
	/**
	 * @param   object $block The block jQuery element.
	 * @param   object attributes The block attributes (only available when editing).
	 * @return  void
	 */

	let _$block;

	const initVideo = video => {
		const sources = video.find('source');

		if (video.length && sources.length) {
			const windowWidth = window.innerWidth ? window.innerWidth : $(window).width();

			sources.each((index, source) => {
				const minWidth = $(source).data('min-width');
				const videoSrc = $(source).data('src');

				if (windowWidth > minWidth) {
					$(source).attr('src', videoSrc);
					video.get(0).load();

					return false;
				}
			});
		}
	};

	const initializeSwiper = container => {
		/* eslint-disable no-unused-vars */
		const swiper = new Swiper(container, {
			slidesPerView: 1,
			centeredSlides: true,
			autoplay: {
				delay: $(container).data('delay'),
				disableOnInteraction: false
			},
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			loop: true,
			navigation: false,
			pagination: false,
			speed: $(container).data('speed')
		});
		/* eslint-enable no-unused-vars */
	};

	const scrollToBottom = e => {
		e.preventDefault();

		const position = _$block.position();
		const height = _$block.outerHeight();

		gsap.to(window, {
			duration: 0.5,
			scrollTo: {
				y: Math.round(position.top + height),
				offsetY: $('.js-header').outerHeight(),
				autoKill: true
			},
			ease: 'power2'
		});
	};

	const initializeBlock = $block => {
		_$block = $block;

		const video = $block.find('video');
		initVideo(video);

		const container = $block.find('.swiper-container').get(0);
		initializeSwiper(container);

		const scrollTo = $block.find('.js-scroll-to-bottom');
		scrollTo.on('click', scrollToBottom);
	};

	// Initialize each block on page load (front end).
	$(document).ready(() => {
		$('.wp-block-video-header').each((i, el) => {
			initializeBlock($(el));
		});
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction('render_block_preview/type=video-header', initializeBlock);
	}
})(jQuery);